module.exports = __webpack_public_path__ + "9247eea8c18db7ab263831b624a2de3b.svg";